/* ============================================================
   cluburban
   ============================================================ */

export const cluburban = {
    id: "4",
    type: "playlist",
    featured: true,
    title: "Club Urbano",
    link: "club-urbano",
    playlistBg: "rgb(95, 74, 255)",
    imgUrl: "../image/set/urbano/urbano01.jpg",  ///image/set/urbano.jpg
    hoverColor: "rgb(95, 74, 255)",
    artist: "alibhtty",
    artistImgUrl: "../image/djs/alibhtty/alibhtty.jpg",
    artistBio: "room-edition",
    artistDownload: "Descargar",
    bannerUno: "",
    downloadData: [],
    playlistData: [
      {
        id: "1",
        songName: "Club Urbano 01",
        songimg: "../image/set/urbano/urbano01.jpg",
        songArtist: "Ali Bhtty, cyborg",
        artistLink: "alibhtty",
        link: "https://dl.dropbox.com/scl/fi/hxmbva1tpo9ecwv2iqzdw/Club-Urbano-01.m4a?rlkey=n4t40ot0gtqo80u9ow9e6srde&dl=1",
        trackTime: "23:37"
      }
    ]
  }
